import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function Series1() {
  return (
    <BackgroundWrapper>
      
      <div className="pt-8 pb-20 px-4 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/enlightened-leadership"
            className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center mb-8"
          >
            ← Back to Enlightened Leadership
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-10 md:p-16">
            <h1 className="sm:text-3xl text-1xl md:text-4xl font-bold text-slate-800 mb-6">
              Series 1 – The Challenge of Leadership
            </h1>

            <p className="sm:text-lg text-sm text-slate-700 mb-6 leading-relaxed">
              This stage serves as a smooth transition from traditional leadership
              development programs into the interactive “Enlightened Leadership” approach. 
              It introduces both the good and the bad sides of great leadership, then
              moves toward self-searching and awareness, helping participants to 
              understand and fine-tune their own leadership style and behaviors.
            </p>

            <h2 className="sm:text-lg text-sm font-semibold text-slate-800 mb-4">Content</h2>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Part 1 – Leadership Style</li>
              <li>Part 2 – Ethics and Influence</li>
              <li>Part 3 – Values and Behavior</li>
            </ul>

            <p className="text-slate-700 leading-relaxed mb-4 sm:text-lg text-sm">
              By studying historical leaders and applying reflective coaching,
              participants build a deep awareness of how ethics and values define
              their credibility and long-term influence. The result is a more
              authentic, self-aware leader capable of aligning values with action.
            </p>

            <p className="text-slate-600 text-sm">
              <strong>Method:</strong> Seminar  ·  Group Coaching  ·  Selected Individual Coaching
            </p>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
